import { render } from "./TextForm.vue?vue&type=template&id=3ef12995&scoped=true"
import script from "./TextForm.vue?vue&type=script&lang=js"
export * from "./TextForm.vue?vue&type=script&lang=js"

import "./TextForm.vue?vue&type=style&index=0&id=3ef12995&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef12995"]])

export default __exports__